<div class="chart-container boxGaugeChart">
    <canvas id="{{ this.chartId }}">{{ chart }}</canvas>
</div>
<div style="text-align: center">{{ title }}</div>
